import { Alert } from '@components/display/alerts';
import { AlertTitle, Typography } from '@mui/material';
import { PrefixedLink } from '@utils/route';
import clsx from 'clsx';
import { LinkProps } from 'react-router-dom';

interface ISuccessToastProps {
    title?: string;
    msg?: string | string[];
    containerClassName?: string;
    linkProps?: LinkProps & {
        hrefText?: string;
    };
}

const SuccessToast = ({ msg, linkProps, title = 'SUCCESS', containerClassName }: ISuccessToastProps) => {
    return (
        <div className="flex gap-2 items-center">
            <div className="min-h-[66px] w-1 bg-success" />
            <div>
                <Typography
                    className="leading-7"
                    color={'success'}
                    fontFamily={'museo-sans'}
                    lineHeight={'28px'}
                    fontSize={12}
                    fontWeight={700}
                    letterSpacing={'-0.025em'}
                >
                    {title}
                </Typography>

                <div className={clsx('min-w-[375px] text-black text-sm font-roboto', containerClassName)}>
                    {Array.isArray(msg) ? (
                        msg.map((message, index) => (
                            <Typography key={index} className={index > 0 ? 'mt-1' : ''}>
                                {message}
                            </Typography>
                        ))
                    ) : (
                        <Typography>{msg}</Typography>
                    )}

                    {linkProps ? (
                        <PrefixedLink
                            className="text-spanish-blue tracking-tight leading-7 text-xs font-bold"
                            {...linkProps}
                        >
                            {linkProps.hrefText}
                        </PrefixedLink>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

const SuccessAlertToast = ({ msg, linkProps, title = 'SUCCESS' }: Omit<ISuccessToastProps, 'containerClassName'>) => (
    <Alert.Success noStyle>
        <AlertTitle>{title}</AlertTitle>
        {msg}
        {linkProps ? (
            <>
                <br />
                <PrefixedLink className="text-spanish-blue tracking-tight leading-7 text-xs font-bold" {...linkProps}>
                    {linkProps.hrefText}
                </PrefixedLink>
            </>
        ) : null}
    </Alert.Success>
);

export { SuccessAlertToast, SuccessToast };
export type { ISuccessToastProps };
